import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import DigitadorDashboard from "../pages/Digitador/Dashboard";
import DigitadorGerenciamentoPro from "../pages/Digitador/GerenicamentoDeProcessos";
import DigitadorConsulta from "../pages/Digitador/Consulta";

import Sidebar from "../components/Sidebar";

function TypistRoutes() {
	return (
		<Switch>
			<Route path='/dashboard'>
				<Sidebar />
				<DigitadorDashboard />
			</Route>
			<Route path='/gerenciamento-de-processos'>
				<Sidebar />
				<DigitadorGerenciamentoPro />
			</Route>
			<Route path='/consulta'>
				<Sidebar />
				<DigitadorConsulta />
			</Route>
			<Route path='/consulta&id=:id&place=:place'>
				<Sidebar />
				<DigitadorConsulta />
			</Route>

			<Redirect to='dashboard' />
		</Switch>
	);
}

export default TypistRoutes;
